import _ from 'lodash';
import React from 'react';
import { Image } from 'console-kit';

const MULTIPLE_RESULTS_LAYOUT_TYPE = {
  STACK:    'stack',
  CAROUSEL: 'carousel',
};

MULTIPLE_RESULTS_LAYOUT_TYPE.ALL = _.values(MULTIPLE_RESULTS_LAYOUT_TYPE);

MULTIPLE_RESULTS_LAYOUT_TYPE.CONFIGS = {
  [MULTIPLE_RESULTS_LAYOUT_TYPE.STACK]: {
    text:  'Stack',
    value: MULTIPLE_RESULTS_LAYOUT_TYPE.STACK,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-template-vertical.svg'} />,
  },
  [MULTIPLE_RESULTS_LAYOUT_TYPE.CAROUSEL]: {
    text:  'Carousel',
    value: MULTIPLE_RESULTS_LAYOUT_TYPE.CAROUSEL,
    image: <Image src={App.globalContext.assetURL + 'c/img/module-editor/gallery/layouts/basic-carousel.svg'} />,
  },
};

MULTIPLE_RESULTS_LAYOUT_TYPE.RADIO_LIST = [
  MULTIPLE_RESULTS_LAYOUT_TYPE.CONFIGS[MULTIPLE_RESULTS_LAYOUT_TYPE.CAROUSEL],
  MULTIPLE_RESULTS_LAYOUT_TYPE.CONFIGS[MULTIPLE_RESULTS_LAYOUT_TYPE.STACK],
];

export default MULTIPLE_RESULTS_LAYOUT_TYPE;
